/**
 * NotificationBanner — 밴드 0 "오늘 할 일" 알림 배너 (Task 4)
 *
 * computeBannerItems 결과가 null 이면 아무것도 렌더하지 않는다.
 * danger 칩이 하나라도 있으면 배너 전체 톤 danger, 아니면 warning.
 * metric 있는 칩은 클릭 시 onChipClick 호출(상세 Drawer), 없으면 비클릭.
 */

import { Alert } from '@/ui'
import { computeBannerItems, type BannerInput } from './metrics'
import type { DrawerMetric } from './DetailDrawer'
import styles from './NotificationBanner.module.css'

interface NotificationBannerProps {
  input: BannerInput
  onChipClick: (metric: DrawerMetric) => void
}

export function NotificationBanner({ input, onChipClick }: NotificationBannerProps) {
  const banner = computeBannerItems(input)
  if (!banner) return null

  return (
    <Alert variant={banner.tone} title="오늘 할 일">
      <div className={styles.chips}>
        {banner.chips.map((chip) =>
          chip.metric ? (
            <button
              key={chip.key}
              type="button"
              className={styles.chip}
              onClick={() => onChipClick(chip.metric!)}
            >
              {chip.label}
            </button>
          ) : (
            <span key={chip.key} className={styles.chip}>
              {chip.label}
            </span>
          ),
        )}
      </div>
    </Alert>
  )
}
